module.exports = __webpack_public_path__ + "img/AE.4875cd33.svg";